import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { gosafeApi } from "../../api";
import {
  loadingScheduleEvents,
  loadedScheduleEvents,
  failedScheduleEvents,
  changeFilters,
} from "../../store/doctor/dailyAssessmentSlice";
import { translations } from "../../helpers";

export const useDailyAssessmentStore = () => {
  const dispatch = useDispatch();

  const { scheduleEvents, filters } = useSelector(
    (state) => state.doctor.dailyAssessment
  );

  const getDailyAssessmentEvents = useCallback(
    async ({ filters }) => {
      try {
        dispatch(loadingScheduleEvents());

        // console.log("filters", filters);

        const filteredParams = Object.fromEntries(
          Object.entries({
            ...filters,
          }).filter(([_, value]) => value !== "")
        );

        // console.log("filteredParams", filteredParams);

        const { data } = await gosafeApi.get("doctor/dailyAssessmentEvents", {
          params: filteredParams,
        });

        // console.log("data", data);

        dispatch(loadedScheduleEvents(data));

        return;
      } catch (error) {
        dispatch(
          failedScheduleEvents(
            translations[error?.response?.data?.message] ||
              error?.response?.data?.message ||
              error?.message
          )
        );
        return;
      }
    },
    [dispatch]
  );

  const startChangeDate = useCallback(
    (filters) => {
      dispatch(changeFilters(filters));
      getDailyAssessmentEvents({ filters });
    },
    [dispatch, getDailyAssessmentEvents]
  );

  return {
    // Props
    scheduleEvents,
    filters,

    // Methods
    getDailyAssessmentEvents,
    startChangeDate,
  };
};
